import { useMemo } from 'react';
import {
    ESTADO_EN_FINANZAS,
    ESTADO_FINALIZADA,
    ESTADO_MAS_INFORMACION,
    getEstadoId,
} from '../../utils';
import LoadingInline from '../layout/LoadingInline';
import DetalleRevisionView from './DetalleRevisionView';
import DetalleFinanzasView from './DetalleFinanzasView';
import DetalleMasInformacionView from './DetalleMasInformacionView';

const DetalleSolicitudModal = ({
    currentItem,
    detalleIntent = 'ver',
    onClose,
    onSolicitudUpdated,
}) => {
    const viewMode = useMemo(() => {
        if (!currentItem?.id) return null;

        const estadoId = Number(getEstadoId(currentItem));

        if (estadoId === ESTADO_MAS_INFORMACION) {
            return detalleIntent === 'aportar' ? 'masInformacion' : 'revision';
        }
        if (estadoId === ESTADO_EN_FINANZAS) {
            return 'finanzas';
        }
        if (estadoId === ESTADO_FINALIZADA) {
            return 'revision';
        }
        return 'revision';
    }, [currentItem, detalleIntent]);

    if (viewMode === null) {
        return <LoadingInline />;
    }

    if (viewMode === 'masInformacion') {
        return (
            <DetalleMasInformacionView
                currentItem={currentItem}
                onClose={onClose}
                onSolicitudUpdated={onSolicitudUpdated}
            />
        );
    }

    if (viewMode === 'finanzas') {
        return (
            <DetalleFinanzasView
                currentItem={currentItem}
                onClose={onClose}
                onSolicitudUpdated={onSolicitudUpdated}
            />
        );
    }

    return (
        <DetalleRevisionView
            currentItem={currentItem}
            onClose={onClose}
            onSolicitudUpdated={onSolicitudUpdated}
        />
    );
};

export default DetalleSolicitudModal;
